type Entries<T> = {
  [K in keyof T]: [K, T[K]];
}[keyof T][];

/**
 * Same as ./objectKeys.ts but for Object.entries
 *
 * @see https://www.charpeni.com/blog/properly-type-object-keys-and-object-entries
 */
export default function objectEntries<T extends object>(object: T): Entries<T> {
  return Object.entries(object) as Entries<T>;
}
